<div class="app-shell" [class.sidebar-collapsed]="effectiveSidebarCollapsed">
  <!-- Sidebar -->
  <app-college-sidebar
    [activePage]="activePage"
    [unreadCount]="unreadNotificationsCount"
    [institutionName]="settings.institutionName"
    [placementOfficer]="settings.placementOfficer"
    [isCollapsed]="effectiveSidebarCollapsed"
    (pageChange)="onPageChange($event)"
    (logout)="onSignOut()"
    (toggleCollapse)="toggleSidebar()">
  </app-college-sidebar>

  <!-- Main Work Area -->
  <main class="main-area">
    <!-- Topbar Header -->
    <app-college-header
      [activePage]="activePage"
      [academicYear]="settings.academicYear"
      [department]="settings.department"
      [institutionName]="settings.institutionName"
      [placementOfficer]="settings.placementOfficer"
      [collegeLogoUrl]="collegeLogoUrl"
      [deptOptions]="deptOptions"
      [availableYears]="availableYears"
      (yearChange)="onYearChange($event)"
      (departmentChange)="onDeptChange($event)"
      (openProfile)="onOpenProfile()"
      (signOut)="onSignOut()">
    </app-college-header>

    <!-- Dynamic Pages View -->
    <app-college-overview
      *ngIf="activePage === 'Overview'"
      (viewAllJobs)="onPageChange('Companies & Jobs')"
      (selectJob)="onSelectJob($event)"
      (selectStudent)="onSelectStudent($event)"
      (openAttention)="onOpenAttention($event)">
    </app-college-overview>

    <app-college-students
      *ngIf="activePage === 'Students'"
      (viewStudentByUserId)="onViewStudentByUserId($event)">
    </app-college-students>

    <app-college-jobs
      *ngIf="activePage === 'Companies & Jobs'"
      (selectJob)="onSelectJob($event)">
    </app-college-jobs>

    <app-college-readiness
      *ngIf="activePage === 'Placement Readiness'"
      (selectStudent)="onSelectStudent($event)">
    </app-college-readiness>

    <app-college-notifications
      *ngIf="activePage === 'Notifications'">
    </app-college-notifications>

    <app-college-settings
      *ngIf="activePage === 'Settings'"
      [availableYears]="availableYears">
    </app-college-settings>

    <app-college-profile
      *ngIf="activePage === 'Profile'"
      (profileSaved)="onProfileSaved($event)">
    </app-college-profile>
  </main>
</div>

<!-- Toast: outside app-shell to avoid stacking context issues -->
<div *ngIf="toastMessage" class="toast">
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
  <span>{{ toastMessage }}</span>
</div>

<!-- Modals: outside app-shell so position:fixed is relative to viewport, not flex container -->
<app-student-profile-modal
  *ngIf="selectedStudent"
  [student]="selectedStudent"
  (close)="selectedStudent = null"
  (viewReadiness)="onViewReadiness($event)">
</app-student-profile-modal>

<app-student-profile-modal
  *ngIf="selectedStudentUserId"
  [studentUserId]="selectedStudentUserId"
  (close)="selectedStudentUserId = null">
</app-student-profile-modal>

<app-job-detail-modal
  *ngIf="selectedJobId"
  [jobId]="selectedJobId"
  (close)="selectedJobId = null">
</app-job-detail-modal>

<app-readiness-profile-modal
  *ngIf="readinessStudent"
  [student]="readinessStudent"
  (close)="readinessStudent = null">
</app-readiness-profile-modal>

<!-- Profile click now navigates to the real /college-profile page instead of this mocked modal.
<app-officer-profile-modal
  *ngIf="isOfficerProfileOpen"
  [institutionName]="settings.institutionName"
  [placementOfficer]="settings.placementOfficer"
  [contactEmail]="settings.contactEmail"
  (close)="isOfficerProfileOpen = false"
  (save)="onSaveOfficerProfile($event)">
</app-officer-profile-modal>
-->

<app-attention-detail-modal
  *ngIf="isAttentionModalOpen"
  [initialCategory]="activeAttentionCategory"
  (close)="isAttentionModalOpen = false"
  (selectStudent)="onSelectStudent($event)"
  (selectJob)="onSelectJob($event)">
</app-attention-detail-modal>
